<div class="main-container">
  <nz-breadcrumb>
    <nz-breadcrumb-item>首页</nz-breadcrumb-item>
    <nz-breadcrumb-item>仪表盘</nz-breadcrumb-item>
  </nz-breadcrumb>
  <div class="top-sum flex-box">
    <div class="left">
      <div class="item">
        <div class="title">今日报告量</div>
        <div class="num">25</div>
        <div class="des">较昨日 <span class="green">+50%</span></div>
      </div>
      <div class="item">
        <div class="title">今日审核量</div>
        <div class="num">2</div>
        <div class="des">较昨日 <span class="red">-30%</span></div>
      </div>
    </div>
    <div class="right">
      <div class="item">
        <div class="title">本月被退回数量</div>
        <div class="num">3</div>
        <div class="des">较上月 <span class="red">-60%</span></div>
      </div>
    </div>
  </div>
  <div class="chart-box flex-box">
    <div class="left">
      <div class="chat-item">
        <div class="title">
          <div class="t">个人工作量</div>
          <div class="options">
            <div class="item">今日</div>
            <div class="item">本周</div>
            <div class="item">本月</div>
            <div class="item active">本年</div>
          </div>
        </div>
        <div id="work-chart" style="width: 100%; height: 490px"></div>
      </div>
    </div>
    <div class="right">
      <div class="chat-item">
        <div class="title">
          <div class="t">诊断量总数<span>(分模态)</span></div>
          <div class="options">
            <div class="item">今日</div>
            <div class="item">本周</div>
            <div class="item active">本月</div>
          </div>
        </div>
        <div id="mt-chart" style="width: 100%; height: 490px"></div>
      </div>
    </div>
  </div>
  <div class="data-table flex-box">
    <div class="left">
      <div class="detail-table">
        <div class="title">
          <div class="t">数据统计</div>
          <div class="action">
            <button nz-button nzType="primary">查看更多</button>
          </div>
        </div>
        <div class="table">
          <nz-table #basicTable [nzData]="data" [nzPageSize]="5" [nzBordered]="false" [nzSize]="'middle'">
            <thead>
              <tr>
                <th nzWidth="20%">病历号</th>
                <th nzWidth="20%">设备类型</th>
                <th nzWidth="20%">检查部位</th>
                <th nzWidth="20%">上传时间</th>
                <th nzWidth="20%">工作内容</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of basicTable.data">
                <td>{{ data.id }}</td>
                <td>{{ data.mt }}</td>
                <td>{{ data.bodypart }}</td>
                <td>{{ data.uploadTime }}</td>
                <td>
                  {{ data.action }}
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="back-list">
        <div class="title">
          <div class="t">退回详情</div>
          <div class="action">
            <button nz-button nzType="primary">查看全部</button>
          </div>
        </div>
        <div class="table">
          <nz-table #basicTable1 [nzData]="retrunData" [nzShowPagination]="false" [nzBordered]="false" [nzSize]="'middle'">
            <thead>
              <tr>
                <th nzWidth="30%">退回原因</th>
                <th nzWidth="20%">数量</th>
                <th nzWidth="50%">占比</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of basicTable1.data">
                <td>{{ data.reason }}</td>
                <td>{{ data.count }}</td>
                <td>
                  <nz-progress [nzPercent]="data.percent" [nzStrokeColor]="'#e1b13e'"></nz-progress>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="copyright">
  <div class="links">
    <a href="">关于我们</a>
    <a href="">影像社群</a>
    <span> 剩余授权：120天 </span>
  </div>
  <div class="txt">© 2024 Beijing Billico Technology Co., Ltd. All rights reserved.</div>
</div>
